"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AcCardSlider = void 0;
var react_1 = __importStar(require("react"));
var ui_1 = require("@aperza/ui");
var AcCardSliderContainer_1 = require("./AcCardSliderContainer");
var AcCard_1 = require("./AcCard");
var AcCardSlider_module_scss_1 = __importDefault(require("./AcCardSlider.module.scss"));
var AcArrowButton_1 = require("../button/AcArrowButton");
var cardWidth = AcCard_1.AcCardDefaultWidth;
var AcCardSlider = function (_a) {
    var cards = _a.cards, cursor = _a.cursor;
    var sliderContainerRef = react_1.useRef(null);
    var sliderRef = react_1.useRef(null);
    var slideBy = cardWidth + AcCardSliderContainer_1.cardMargin + AcCardSliderContainer_1.cardMargin;
    /**
     * Viewport is the element that covers the slider.
     * It controls the event propagations.
     */
    var viewportRef = react_1.useRef(null);
    var windowWidth = ui_1.useWindowResize().windowWidth;
    var _b = __read(react_1.useState(0), 2), sliderLeft = _b[0], setSliderLeft = _b[1];
    var _c = __read(react_1.useState({}), 2), viewportStyle = _c[0], setViewportStyle = _c[1];
    var _d = __read(react_1.useState('inherit'), 2), viewportPointEvents = _d[0], setViewportPointEvents = _d[1];
    var _e = __read(react_1.useState(), 2), lastClickPoint = _e[0], setLastClickPoint = _e[1];
    /**
     * Timestamp when the user triggers mouse down event
     */
    var _f = __read(react_1.useState(0), 2), startSliderMouseDown = _f[0], setStartSliderMouseDown = _f[1];
    var _g = __read(react_1.useState(0), 2), startSliderMouseX = _g[0], setStartSliderMouseX = _g[1];
    var _h = __read(react_1.useState(0), 2), startSliderLeft = _h[0], setStartSliderLeft = _h[1];
    var _j = __read(react_1.useState(0), 2), mouseDownX = _j[0], setMouseDownX = _j[1];
    react_1.useEffect(function () {
        if (sliderContainerRef.current && sliderRef.current && viewportRef.current) {
            var sliderContainer = sliderContainerRef.current;
            setViewportStyle({
                width: sliderContainer.clientWidth,
                height: sliderContainer.clientHeight,
            });
        }
    }, [windowWidth]);
    react_1.useEffect(function () {
        if (viewportPointEvents && viewportPointEvents === 'none') {
            if (lastClickPoint) {
                var clickedElement = document.elementFromPoint(lastClickPoint.x, lastClickPoint.y);
                clickedElement.click();
            }
            setViewportPointEvents('inherit');
        }
    }, [viewportPointEvents]);
    var now = function () {
        return new Date().getTime();
    };
    var elapsed = function (time) {
        return now() - time;
    };
    var sliderContainerWidth = function () {
        if (sliderContainerRef.current)
            return sliderContainerRef.current.clientWidth;
        return 0;
    };
    var sliderWidth = function () {
        // in IE11, the width of hidden part of a div is ignored thus the sliderWidth must be counted manually.
        // if (sliderRef.current) return sliderRef.current.clientWidth;
        if (sliderRef.current && cards && cards.length > 0) {
            var totalCardWidth = cards.length * cardWidth;
            var totalMargin = (cards.length - 1) * AcCardSliderContainer_1.cardMargin * 2;
            return totalCardWidth + totalMargin;
        }
        return 0;
    };
    var isInViewport = function (e) {
        var viewport = viewportRef.current;
        if (viewport) {
            var viewportRect = viewport.getBoundingClientRect();
            var clientX = e.clientX, clientY = e.clientY;
            if (clientX >= viewportRect.left &&
                clientX <= viewportRect.right &&
                clientY >= viewportRect.top &&
                clientY <= viewportRect.bottom)
                return true;
        }
        return false;
    };
    var slideToLeft = function () {
        var _a, _b;
        var sliderBox = (_a = sliderRef.current) === null || _a === void 0 ? void 0 : _a.getBoundingClientRect();
        var sliderContainerBox = (_b = sliderContainerRef.current) === null || _b === void 0 ? void 0 : _b.getBoundingClientRect();
        // @ts-ignore
        if (sliderWidth() < sliderContainerBox.width) {
            setSliderLeft(0);
            return;
        }
        // the sliderBox.right is not calculated correctly in IE - it cuts off the right side when hidden
        // @ts-ignore
        if ((sliderBox === null || sliderBox === void 0 ? void 0 : sliderBox.left) + sliderWidth() - slideBy < (sliderContainerBox === null || sliderContainerBox === void 0 ? void 0 : sliderContainerBox.right)) {
            // @ts-ignore
            setSliderLeft(sliderContainerBox.width - sliderWidth());
        }
        else {
            setSliderLeft(sliderLeft - slideBy);
        }
    };
    var slideToRight = function () {
        var _a, _b;
        var sliderBox = (_a = sliderRef.current) === null || _a === void 0 ? void 0 : _a.getBoundingClientRect();
        var sliderContainerBox = (_b = sliderContainerRef.current) === null || _b === void 0 ? void 0 : _b.getBoundingClientRect();
        // @ts-ignore
        if (sliderWidth() < sliderContainerBox.width) {
            setSliderLeft(0);
            return;
        }
        // @ts-ignore
        if ((sliderBox === null || sliderBox === void 0 ? void 0 : sliderBox.left) + slideBy > (sliderContainerBox === null || sliderContainerBox === void 0 ? void 0 : sliderContainerBox.left)) {
            // @ts-ignore
            setSliderLeft(0);
        }
        else {
            setSliderLeft(sliderLeft + slideBy);
        }
    };
    var sliderMouseDown = function (e) {
        setStartSliderMouseDown(now());
        setStartSliderMouseX(e.clientX);
        setStartSliderLeft(sliderLeft);
        setMouseDownX(e.clientX);
    };
    var sliderMouseMove = function (e) {
        var moved = startSliderMouseX - e.clientX;
        if (!isInViewport(e)) {
            setStartSliderMouseDown(0);
        }
        else if (startSliderMouseDown) {
            var newLeft = sliderLeft - moved;
            if (newLeft < 0 && sliderWidth() + newLeft > sliderContainerWidth())
                setSliderLeft(sliderLeft - moved);
            setStartSliderMouseX(e.clientX);
        }
    };
    var sliderMouseMoveUp = function (e) { };
    var sliderMouseMoveOut = function (e) {
        if (!isInViewport(e)) {
            setStartSliderMouseDown(0);
        }
    };
    /**
     * Click event always happens after mouse move up thus we only need to handle click.
     * Need to decide whether to pass thru the click to the underlying components.
     * Element with absolute position is unable to automatically propagate the events to the elements underneath.
     * @param e
     */
    var sliderClick = function (e) {
        setStartSliderMouseDown(0);
        if (Math.abs(mouseDownX - Math.round(e.clientX)) <= 1) {
            setViewportPointEvents('none');
            setLastClickPoint({ x: e.clientX, y: e.clientY });
        }
        setStartSliderLeft(sliderLeft);
    };
    return (react_1.default.createElement("div", { className: "w-100 d-flex align-items-center position-relative user-select-none" },
        react_1.default.createElement(AcArrowButton_1.AcArrowButton, { direction: "left", height: 80, width: 32, variant: "sub3", className: "mr-2 " + AcCardSlider_module_scss_1.default.navButton, onClick: slideToRight }),
        react_1.default.createElement(AcCardSliderContainer_1.AcCardSliderContainer, { cards: cards, sliderLeft: sliderLeft, sliderContainerRef: sliderContainerRef, sliderRef: sliderRef },
            react_1.default.createElement("div", { ref: viewportRef, draggable: false, className: "position-absolute", style: __assign({ pointerEvents: viewportPointEvents, zIndex: 100, top: 0, left: 0, cursor: cursor }, viewportStyle), onMouseDown: sliderMouseDown, onMouseMove: sliderMouseMove, onMouseUp: sliderMouseMoveUp, onMouseOut: sliderMouseMoveOut, onClick: sliderClick })),
        react_1.default.createElement(AcArrowButton_1.AcArrowButton, { direction: "right", height: 80, width: 32, variant: "sub3", className: "ml-2 " + AcCardSlider_module_scss_1.default.navButton, onClick: slideToLeft })));
};
exports.AcCardSlider = AcCardSlider;
exports.AcCardSlider.displayName = 'AcCardSlider';
//# sourceMappingURL=AcCardSlider.js.map